import React from 'react'
import { Grid } from 'src/component/ui/grid/grid'
import { SeriesCardSkeleton } from 'src/component/ui/series-card'

export const ActiveSeriesScreenSkeleton = (): React.ReactElement => {
  return (
    <Grid.Skeleton count={6}>
      <SeriesCardSkeleton variant="active" />
    </Grid.Skeleton>
  )
}
